import renderConfirmBagRemovalModal from "../../../infrastructure/renders/ConfirmBagRemovalModal";

export default function confirmBenefitBagRemoval({ country, callback }) {
  renderConfirmBagRemovalModal({ country, callback });
}
